import React from 'react';
import { Users, CheckCircle, XCircle, ShieldCheck } from 'lucide-react';

const ClientStats = ({ 
  totalClients = 0,
  activeClients = 0,
  inactiveClients = 0,
  verifiedClients = 0,
  className = ''
}) => {
  const stats = [
    {
      key: 'total',
      title: 'Total Clients',
      value: totalClients,
      icon: Users,
      bgColor: 'bg-gray-50',
      darkBgColor: 'dark:bg-gray-900/80',
      borderColor: 'border-gray-200',
      darkBorderColor: 'dark:border-gray-700',
      iconBg: 'bg-gray-100',
      darkIconBg: 'dark:bg-gray-800',
      iconColor: 'text-gray-600'
    },
    {
      key: 'active',
      title: 'Active',
      value: activeClients,
      icon: CheckCircle,
      bgColor: 'bg-green-50',
      darkBgColor: 'dark:bg-green-900/20',
      borderColor: 'border-green-200',
      darkBorderColor: 'dark:border-green-700/40',
      iconBg: 'bg-green-100',
      darkIconBg: 'dark:bg-green-900/30',
      iconColor: 'text-green-600'
    },
    {
      key: 'inactive',
      title: 'Inactive',
      value: inactiveClients,
      icon: XCircle,
      bgColor: 'bg-red-50',
      darkBgColor: 'dark:bg-red-900/20',
      borderColor: 'border-red-200',
      darkBorderColor: 'dark:border-red-700/40',
      iconBg: 'bg-red-100',
      darkIconBg: 'dark:bg-red-900/30',
      iconColor: 'text-red-600'
    },
    {
      key: 'verified',
      title: 'Verified',
      value: verifiedClients,
      icon: ShieldCheck,
      bgColor: 'bg-blue-50',
      darkBgColor: 'dark:bg-blue-900/20',
      borderColor: 'border-blue-200',
      darkBorderColor: 'dark:border-blue-700/40',
      iconBg: 'bg-blue-100',
      darkIconBg: 'dark:bg-blue-900/30',
      iconColor: 'text-blue-600'
    }
  ];

  return (
    <div className={`grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 ${className}`}>
      {stats.map((stat) => {
        const Icon = stat.icon;
        return (
          <div
            key={stat.key}
            className={`${stat.bgColor} ${stat.darkBgColor} ${stat.borderColor} ${stat.darkBorderColor} rounded-lg border p-5 flex items-center gap-4 hover:shadow-md transition-shadow duration-200`}
          >
            <div className={`${stat.iconBg} ${stat.darkIconBg} ${stat.iconColor} p-3 rounded-full flex-shrink-0`}>
              <Icon className="h-6 w-6" />
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-sm font-medium text-gray-600 dark:text-gray-300 mb-1">
                {stat.title}
              </p>
              <p className="text-3xl font-bold text-gray-900 dark:text-white">
                {stat.value.toLocaleString()}
              </p>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default ClientStats;
